import { HomeGroupLayout, ExtraLearningContent } from 'components';
import React from 'react';

export const ExtraLearningPage = () => {
    return (
        <HomeGroupLayout>
            <ExtraLearningContent />
        </HomeGroupLayout>
    );
};